


















import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
    name: "PLPrintHeader"
})
export default class extends Vue {
    @Prop({ required: true, type: String }) readonly title!: string;
    @Prop({ required: true, type: String }) readonly createdDate!: string;
    @Prop({ required: true, type: String }) readonly code!: string;
}
